import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import CheckBox from "../../form/CheckBox";
import GroupDiscount from "./Discount/GroupDiscount";
import Conditions from "./Discount/Conditions";
import classNames from 'classnames';
import {CurrencyFormatter} from "../../../utils/formatters";
import Tabs from "../../layout/Tabs";
import TabContent from "../../layout/TabContent";
import Icon from "../../form/Icon";
import PropsProxy from "../../layout/PropsProxy";
import {loadComponent} from "../../../utils/components";
import debounce from "../../../utils/debounce";

class CheckPromoCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inUse: [],
            everInUse: [],
        }
        const load = () => {
            const promo_code = (this.props.code || "").trim();
            this.setState({inUse: [], everInUse: []});
            if (this.props.code) {
                this.inUseRequest = loadComponent("componentlist", {
                    component: this.props.componentConfig.componentname,
                    filter: [
                        {
                            field: this.props.componentConfig.idfield,
                            value: this.props.id || 0,
                            operator: "!="
                        },
                        {
                            field: "promo_code",
                            value: promo_code
                        },
                        {
                            field: "active",
                            value: 1
                        }
                    ]
                });
                this.inUseRequest.then((response) => {
                    if (promo_code === (this.props.code || "").trim()) {
                        this.setState({inUse: response.items});
                    }
                });
                this.everInUseRequest = loadComponent("componentlist", {
                    component: this.props.componentConfig.componentname,
                    filter: [
                        {
                            field: this.props.componentConfig.idfield,
                            value: this.props.id || 0,
                            operator: "!="
                        },
                        {
                            field: "promo_code",
                            value: promo_code
                        },
                        {
                            field: "active",
                            value: 0
                        }
                    ]
                });
                this.everInUseRequest.then((response) => {
                    if (promo_code === (this.props.code || "").trim()) {
                        this.setState({everInUse: response.items});
                    }
                });
            }
        }
        this.loadInUse = debounce(load, 300);
        load();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.id !== this.props.id || (prevProps.code || "").trim() !== (this.props.code || "").trim()) {
            this.loadInUse();
        }
    }

    componentWillUnmount() {
        this.loadInUse.cancel();
        this.inUseRequest && this.inUseRequest.abort();
        this.everInUseRequest && this.everInUseRequest.abort();
    }

    render() {
        return (
            <PropsProxy
                warning={
                    this.state.inUse.length || this.state.everInUse.length ?
                        <Fragment>
                            {!!this.state.inUse.length && <Fragment>
                                Jelenleg a(z) {this.state.inUse.map((discount, idx) => {
                                return <span key={idx}>{discount.name} (#{discount.id}) {idx !== this.state.inUse.length-1 && ", "}</span>
                            })} {this.state.inUse.length > 1 ? "akciók használják" : "akció használja"} ezt a kupon kódot!
                            </Fragment>}
                            {!!this.state.everInUse.length && <Fragment>
                                Egyéb, jelenleg nem aktív akciók is tartalmazzák ezt a kupon kódot! {this.state.everInUse.map((discount, idx) => {
                                return <div key={idx}>{discount.name} (#{discount.id})</div>
                            })}
                            </Fragment>}
                        </Fragment>
                    :
                        undefined
                }
            >
                {this.props.children}
            </PropsProxy>
        );
    }
}

class DiscountForm extends React.Component {

    render() {
        let discountprops = null;
        let ultimate = null;
        let combinable = null;
        let defaultTab = "targets";
        if (this.props.values.type === "groupdiscount") {
            defaultTab = "conditions";
            discountprops = <TabContent
                tabName="conditions"
                tabLabel={<Fragment>
                    <Icon lib="fas" name="filter" /> Kedvezmény feltétel szűrések
                </Fragment>}
            >
                <GroupDiscount
                    {...this.props}
                />
            </TabContent>
            combinable = <Select
                {...this.props.getFieldProps("combinable")}
                label={false}
                optionname="DiscountCanCombine"
                storeType="local"
                objectValue={false}
                name="combinable"
                value={this.props.values.combinable}
                saveChanges={this.props.setFieldValue}
            />;
        } else if(this.props.values.type === "itemdiscount") {
            ultimate = <CheckBox
                {...this.props.getFieldProps("ultimate")}
                name="ultimate"
                value={this.props.values.ultimate}
                label="Kötelező kedvezmény"
                saveChanges={this.props.setFieldValue}
            />;
        }
        if (this.props.values.type !== "groupdiscount") {
            combinable = <CheckBox
                {...this.props.getFieldProps("combinable")}
                name="combinable"
                value={this.props.values.combinable}
                label={false}
                saveChanges={this.props.setFieldValue}
            />;
        }
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <div className="form-group">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <div className="form-group">
                            <TextInput
                                name="name"
                                value={this.props.values.name}
                                label="Név"
                               saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("name")}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-3">
                        <TextInput
                            name="per_user_limit"
                            type="number"
                            value={this.props.values.per_user_limit}
                            label="Felhasználási limit felhasználónként"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("per_user_limit")}
                        />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            name="global_limit"
                            type="number"
                            value={this.props.values.global_limit}
                            label="Felhasználási limit összesen"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("global_limit")}
                        />
                    </div>
                    <div className={classNames({"col-md-6": !ultimate, "col-md-3": ultimate})}>
                        <div className="form-group">
                            <Select
                                {...this.props.getFieldProps("type")}
                                optionname="DiscountType"
                                storeType="local"
                                objectValue={false}
                                name="type"
                                value={this.props.values.type}
                                label="Típus"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    {ultimate && <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">&nbsp;</label>
                            {ultimate}
                        </div>
                    </div>}
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <Select
                                {...this.props.getFieldProps("discount_group")}
                                component="group"
                                storeType="local"
                                objectValue={false}
                                name="discount_group"
                                value={this.props.values.discount_group}
                                isClearable={true}
                                label="Csoport"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                {this.props.values.type === "cartdiscount" ? <div className="row form-row">
                    <div className="col-md-6 currency">
                        <TextInput
                            type="number"
                            name="condition_qty"
                            label="Minimum kosár érték"
                            formatter={CurrencyFormatter}
                            value={this.props.values.condition_qty}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("condition_qty")}
                        />
                    </div>
                </div> : null}
                {this.props.values.type !== undefined &&
                    <Fragment>
                        <div className="row form-row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Kedvezmény</label>
                                    <div className="row">
                                        <div className="col-md-7">
                                            <TextInput
                                                type="number"
                                                name="value"
                                                label={false}
                                                value={this.props.values.value}
                                                saveChanges={this.props.setFieldValue}
                                                {...this.props.getFieldProps("value")}
                                            />
                                        </div>
                                        <div className="col-md-5">
                                            <Select
                                                {...this.props.getFieldProps("calculation_mode")}
                                                label={false}
                                                optionname="DiscountValueType"
                                                filter={this.props.values.type !== "cartdiscount" ? null : {field: "optionid", value: "fix_price", operator: "!="}}
                                                storeType="local"
                                                objectValue={false}
                                                name="calculation_mode"
                                                value={this.props.values.calculation_mode}
                                                saveChanges={this.props.setFieldValue}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <CheckPromoCode
                                        code={this.props.values.promo_code}
                                        id={this.props.values[this.props.componentConfig.idfield]}
                                        componentConfig={this.props.componentConfig}
                                    >
                                        <TextInput
                                            type="text"
                                            name="promo_code"
                                            label="Kupon kód"
                                            value={this.props.values.promo_code}
                                            saveChanges={this.props.setFieldValue}
                                            {...this.props.getFieldProps("promo_code")}
                                        />
                                    </CheckPromoCode>
                                </div>
                                <div className="form-group">
                                    <label className="control-label">Összevonható</label>
                                    {combinable}
                                </div>
                            </div>
                            {this.props.values.type !== "cartdiscount" && <div className="col-md-8">
                                <Tabs defaultTab={defaultTab}>
                                    {discountprops}
                                    <TabContent
                                        tabName="targets"
                                        tabLabel={<Fragment><Icon lib="fas" name="map-marker" /> Kedvezmény cél szűrések</Fragment>}
                                    >
                                        <Conditions
                                            {...this.props}
                                            type="DiscountTarget"
                                            name="targets"
                                            conditions={this.props.values.targets}
                                            saveChanges={this.props.setFieldValue}
                                        />
                                    </TabContent>
                                    {
                                        this.props.values.type !== "packagediscount"
                                        &&
                                        <TabContent
                                            tabName="exclusion"
                                            tabLabel={<Fragment><Icon lib="fas" name="exclamation" /> Termék kizárás</Fragment>}
                                        >
                                            <Conditions
                                                {...this.props}
                                                type="DiscountExclusion"
                                                name="exclusions"
                                                conditions={this.props.values.exclusions}
                                                saveChanges={this.props.setFieldValue}
                                            />
                                        </TabContent>
                                    }
                                </Tabs>
                            </div>}
                        </div>
                    </Fragment>
                }
            </form>
        );
    }
}

export default createForm(DiscountForm);
